import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() { }

  static getDocData(mainData) {

    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let teeTime = this.getTeeTime(mainData.Times);
    let notes = this.getNotes(mainData.Times);
    let docDefinition = {
      pageMargins: [20, 50, 20, 20],
      header: function (currentPage, pageCount, pageSize) {
        // you can apply any logic and return any valid pdfmake element

        return [
          {
            columns: [
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: "25%",
                text: "",
              },
              {
                // fixed width
                width: "50%",
                alignment: "center",
                bold: true,
                text: [
                  mainData.TITLE + "\n",
                  "TEE SHEET\n",
                  "" + mainData.FI + "" + "\n",
                ],
              },
              {
                // % width
                width: "25%",
                bold: true,
                text: [
                  "Generado: " + mainData.FG + "\n",
                  "Hora: " + mainData.HG + "\n",
                ],
              },
            ],
            // optional space between columns
            columnGap: 10,
          },
        ];
      },
      content: [
        //header

        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                dontBreakRows: true,
                widths: [40, 100, 110, 40, 100, 110],
                heights: 25,
                body: teeTime,
              },
            },
          ],
          margin: [0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTeeTimesGrouper(timesData) {
    let cols = 2;
    let data = [];
    let rowData = [];
    let count = 0;
    let countVert = 0;
    timesData.forEach((time, index) => {
      if (!rowData[count]) {
        rowData[count] = [];
      }
      time.slotPlayers.forEach((ply) => {
        if (ply.length > 0) {
          ply.forEach((item) => {
            let textoNota = item.Notas || "";
            let text = item.Nom + " - " + (item.trfr ? item.trfr : "") + "\n";
            rowData[count].push({
              time: time.time,
              ply: text,
              nota: textoNota,
            });
          });
        } else {
          rowData[count].push({
            time: time.time,
            ply: "",
            nota: "",
          });
        }
      });

      if (count + 1 < cols) {
        if (timesData[index + 1]) {
          count++;
        } else {
          data.push(rowData);
          count = 0;
          rowData = [];
        }
      } else {
        data.push(rowData);
        count = 0;
        rowData = [];
      }
    });
    return data;
  }

  static getTeeTimesGrouperV2(timesData) {
    let cols = 2;
    let everyTimes = 6;
    let counteveryTimes = 1;
    let data = [];
    let rowData = [];
    let count = 0;
    let countVert = 0;
    let countTimes = 0;
    let numberOftimes = timesData.length;
    let timesByColumn = numberOftimes / cols;
    timesData.forEach((time, index) => {
      let timeRow = [];
      console.log(time.slotPlayers)
      time.slotPlayers.forEach((ply) => {
        if (ply.length > 0) {
          let numPlay = 1
          ply.forEach((item) => {
            let textoNota = item.Notas || "";
            let text = item.Nom + " - " + (item.trfr ? item.trfr : "") + " " + (item.bahia ? (item.bahia == 1 ? "Hoyo 1" : "Hoyo 10") : "") + "\n";
            if (numPlay <= 1) {
              timeRow.push({
                time: time.time,
                ply: text,
                nota: textoNota,
              });
            } else {
              timeRow[0].ply = timeRow[0].ply + " | " + text
              timeRow[0].nota = timeRow[0].nota + " | " + textoNota
            }

            numPlay++
          });
        } else {
          timeRow.push({
            time: time.time,
            ply: "",
            nota: "",
          });
        }
      });
      //if(countTimes < timesByColumn && (timesByColumn - countTimes ) > 1){

      if (counteveryTimes <= everyTimes) {
        if (!rowData[count]) {
          rowData[count] = [];
        }
        rowData[count].push(timeRow);
      }
      if (counteveryTimes == everyTimes) {
        if (count == 1) {
          count = 0;
        } else {
          count = 1;
        }
        counteveryTimes = 1;
      } else {
        counteveryTimes++;
      }

      //}else{
      //countTimes = 0
      //count++
      //}
    });



    let sizeOfCol = rowData[0]?.length || 0;
    rowData.forEach((col) => {
      if (col.length >= sizeOfCol) {
        sizeOfCol = col.length;
      }
    });
    let subcounter = 0;
    rowData.forEach((col, index) => {
      col.forEach((row, indexrow) => {
        if (!data[subcounter]) {
          data[subcounter] = [];
        }
        if (!data[subcounter][index]) {
          data[subcounter][index] = [];
        }
        data[subcounter][index] = row;

        if (subcounter + 1 == sizeOfCol) {
          subcounter = 0;
        } else {
          subcounter++;
        }
      });
    });

    return data;
  }

  static getTeeTime(timesData) {
    let datosagrupados = this.getTeeTimesGrouperV2(timesData);
    //let datosv2 = this.getTeeTimesGrouperV2(timesData)
    let times = [
      [
        { text: "Hora", border: [true, false, true, true], fontSize: 12 },
        { text: "Jugador", border: [true, false, true, true], fontSize: 12 },
        { text: "Notas", border: [true, false, true, true], fontSize: 12 },
        { text: "Hora", border: [true, false, true, true], fontSize: 12 },
        { text: "Jugador", border: [true, false, true, true], fontSize: 12 },
        { text: "Notas", border: [true, false, true, true], fontSize: 12 },
      ],
    ];

    datosagrupados.forEach((group) => {
      let size = 0;
      if (!group[0]) {
        group[0] = [];
      }
      if (!group[1]) {
        group[1] = [];
      }
      if (group[0].length == group[1].length) {
        size = group[0].length;
      } else if (group[0].length > group[1].length) {
        size = group[0].length;
      } else {
        group[1].length;
      }

      for (var i = 0; i < size; i++) {
        let subArray = [];
        subArray.push({
          text: group[0][i]?.time,
          border: [true, false, true, true],
          fontSize: 8,
        });
        subArray.push({
          text: group[0][i]?.ply,
          border: [true, false, true, true],
          fontSize: 8,
        });
        subArray.push({
          text: this.truncateText(group[0][i]?.nota),
          border: [true, false, true, true],
          fontSize: 8,
        });
        subArray.push({
          text: group[1][i]?.time,
          border: [true, false, true, true],
          fontSize: 8,
        });
        subArray.push({
          text: group[1][i]?.ply,
          border: [true, false, true, true],
          fontSize: 8,
        });
        subArray.push({
          text: this.truncateText(group[1][i]?.nota),
          border: [true, false, true, true],
          fontSize: 8,
        });
        times.push(subArray);
      }
    });

    return times;
  }
  static truncateText(text) {
    if (text) {
      let trunc = text.substr(0, 50) + "\u2026";
      return trunc;
    } else {
      return "";
    }
  }

  static getNotes(timesData) {
    let times = [
      [
        { text: "Hora", border: [true, false, true, true], fontSize: 12 },
        {
          text: "Jugadores",
          border: [true, false, true, true],
          fontSize: 12,
          alignment: "center",
        },
        { text: "Nota", border: [true, false, true, true], fontSize: 10 },
      ],
    ];
    timesData.forEach((time) => {

      if (time.players.length > 0) {
        let subArray = [];
        subArray.push({
          text: time.time,
          border: [true, false, true, true],
          fontSize: 10,
        });
        let textPlayers = "";
        let textNota = "";
        time.slotPlayers.forEach((ply) => {
          ply.forEach((item) => {
            textPlayers = textPlayers + item.Nom + "\n";
            textNota = item.Notas;
          });
        });
        subArray.push({
          text: textPlayers,
          border: [true, false, true, true],
          fontSize: 10,
        });
        subArray.push({
          text: textNota,
          border: [true, false, true, true],
          fontSize: 10,
        });
        times.push(subArray);
      }
    });
    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      table: {
        body: times,
      },
    };
    return times;
  }
}
